<template>
  <div id="wrap">
    <!-- banner区域 -->
    <div class="banner">
      <div class="bannerText">
        <div>同城帮开放平台</div>
        <div>依靠科技创新，优化产品体验，</div>
        <div>带给大众安全普惠的手机服务解决方案</div>
      </div>
    </div>
    <!-- 内容区 -->
    <div class="wrap">
      <!-- 中间盒子 -->
      <div class="content">
        <div class="title">技术优势</div>
        <div class="line"></div>
        <div class="text">同城帮打通线上线下数据，构建出完善的大数据后台。</div>
        <div class="text">通过数据分析，指导二手买卖有序进行，告别“碰运气”的买卖市场。</div>
        <!-- 列表 -->
        <ul class="list">
          <li>
            <!-- img -->
            <div class="list-img">
              <img src="https://p1.ssl.qhimg.com/t01b1c4449eec2180ca.png" alt />
            </div>
            <!-- title -->
            <div class="list-title">大数据用户系统</div>
            <!-- text -->
            <div class="list-text">多年海量累积，精准数据分析</div>
          </li>

          <li>
            <!-- img -->
            <div class="list-img">
              <img src="https://p4.ssl.qhimg.com/t015f137621d753118a.png" alt />
            </div>
            <!-- title -->
            <div class="list-title">云仓储存服务</div>
            <!-- text -->
            <div class="list-text">“随时取用”，无需为货品储存额外支出</div>
          </li>

          <li>
            <!-- img -->
            <div class="list-img">
              <img src="https://p5.ssl.qhimg.com/t0152152a6451a3f7fc.png" alt />
            </div>
            <!-- title -->
            <div class="list-title">隐私粉碎</div>
            <!-- text -->
            <div class="list-text">隐私粉碎技术</div>
          </li>
        </ul>

        <ul class="list">
          <li>
            <!-- img -->
            <div class="list-img">
              <img src="https://p3.ssl.qhimg.com/t01980bbb71ad3bf8d6.png" alt />
            </div>
            <!-- title -->
            <div class="list-title">新机直卖系统</div>
            <!-- text -->
            <div class="list-text">提供分期工具、租机等服务支持，促进新机销售提升</div>
          </li>

          <li>
            <!-- img -->
            <div class="list-img">
              <img src="https://p3.ssl.qhimg.com/t0189c229717dc7739d.png" alt />
            </div>
            <!-- title -->
            <div class="list-title">二手回收网络</div>
            <!-- text -->
            <div class="list-text">线上、线下门店铺陈众多回收网点，保证便捷回收</div>
          </li>

          <li>
            <!-- img -->
            <div class="list-img">
              <img src="https://p0.ssl.qhimg.com/t01b99a5d574d7924b4.png" alt />
            </div>
            <!-- title -->
            <div class="list-title">智能机型推荐</div>
            <!-- text -->
            <div class="list-text">通过数据分析，智能推荐更受市场欢迎机型</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>

<style  lang="scss" scoped>
#wrap {
  .banner {
    background-image: url("https://p3.ssl.qhimg.com/t01c70e2931c49fd76e.png");
    background-repeat: no-repeat;
    background-size: cover;
    height: 425px;
    position: relative;
    .bannerText {
      color: white;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      div:nth-child(1) {
        font-size: 50px;
        font-weight: 300;
        margin-bottom: 38px;
      }
      div:nth-child(2),
      div:nth-child(3) {
        font-size: 18px;
        font-weight: 400;
        text-align: center;
      }
      div:nth-child(2) {
        margin-bottom: 20px;
      }
    }
  }

  // 内容区
  .wrap {
    margin: 0 auto;
    width: 1200px;
    height: 935px;
    // padding: 146px 0 190px 0;
    padding-top: 145px;
    box-sizing: border-box;
    .content {
      width: 1040px;
      margin: 0 auto;
      .title {
        font-size: 30px;
        font-weight: 200;
        color: #03050e;
        text-align: center;
        margin-bottom: 26px;
      }
      .line {
        width: 62px;
        height: 4px;
        background: #26c9a5;
        margin: 0 auto;
        margin-bottom: 36px;
      }
      .text {
        text-align: center;
        color: #999999;
        font-size: 16px;
        line-height: 23px;
      }
      .list {
        margin-top: 66px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        li {
          width: 290px;
          height: 170px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .list-img {
            width: 70px;
            height: 70px;
            margin-bottom: 30px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .list-title {
            font-size: 24px;
            color: #03050e;
            font-weight: 200;
            margin-bottom: 16px;
          }
          .list-text {
            font-size: 16px;
            font-weight: 200;
            color: #03050e;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>

